package org.teddapp.project.ui

import androidx.compose.runtime.compositionLocalOf

/**
 * Si `true`, les formulaires CRUD (slide-in panels, center modals) basculent
 * en plein écran (mobile). Sinon ils gardent leur style desktop (modal centré
 * ou slide-in 440dp à droite).
 *
 * Le Phone wrap les appels de screens avec
 * `CompositionLocalProvider(LocalUseFullScreenForm provides true) { ... }`.
 */
val LocalUseFullScreenForm = compositionLocalOf { false }
